module.exports = __webpack_public_path__ + "img/pro_two_4.4426fe42.jpg";